/**
 * Created by Pradeep Kumar on 5/29/2019.
 */

import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {TweenLite} from "gsap";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";

export class TombOfNefertitiReelAreaView extends ReelAreaView {

    public static _reelAreaView: TombOfNefertitiReelAreaView;

    private _updateReelAreaMaskCalled: boolean = false;

    constructor(resourcesGroup?: ResourcesGroupName) {
        super(resourcesGroup);

        TombOfNefertitiReelAreaView._reelAreaView = this;
    }

    public onSpinStart(): void {
        const offset: number = 60;

        this.updateMaskProperties(offset);
        this._updateReelAreaMaskCalled = false;

        TweenLite.to(() => {
        }, 0.25, {
            onComplete: () => {
                // #387 the race condition when reel area mask has already been updated by resize(be it viewport or orientation resize),
                // no need to update again.
                if (!this._updateReelAreaMaskCalled) {
                    this.updateMaskProperties(-offset);
                }
            }
        });
    }

    /**
     * @description It is overridden to update mask considering overlapping symbols.
     *
     */
    protected UpdateReelAreaMask(): void {
        super.UpdateReelAreaMask();

        const offset: number = (TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT_FOR_OVERLAPPING_SYMBOLS - TombOfNefertitiGameConfig.instance.SYMBOL_HEIGHT);
        this.updateMaskProperties(offset);
        this._updateReelAreaMaskCalled = true;
    }

    private updateMaskProperties(offset: number): void {
        (<PIXI.Container>this.mask!).y -= offset;
        (<PIXI.Container>this.mask!).height += offset;
    }
}